<app-topnav></app-topnav>

<!-- HEADER -->
<app-header-secondary-h [pageTitle]="'Fenêtres sur la Gestion Pédagogique (FGP)'" 
    [pageDescription]="['L’ensemble des tâches administratives', 'scolaires passe à l’ère numérique']"
    [imageURL]="'assets/img/logiciels/FGP_top.png'" *ngIf="currentLang ==='fr'"></app-header-secondary-h>
<app-header-secondary-h [pageTitle]="'Fenêtres sur la Gestion Pédagogique (FGP)'" 
    [pageDescription]="['The whole range of school-related administrative', 'tasks are now transitioning to the digital era']"
    [imageURL]="'assets/img/logiciels/FGP_top.png'" *ngIf="currentLang ==='en'"></app-header-secondary-h>
<!-- end HEADER -->

<!-- SECTION characteristics -->
<section id="section-characteristics">
    <div id="section-characteristics-inner">
        <div class="container">
            <div class="row">
                <div class="col col-12" *ngIf="currentLang ==='fr'">
                    <h2 class="section-title">
                        <strong>Caractéristiques et avantages</strong>
                    </h2>
                    <p>Certes, l’école est avant tout un lieu d’apprentissage, mais elle représente un milieu de vie pour les élèves. Ce faisant, les intervenants en milieu scolaire doivent voir au bon déroulement de plusieurs aspects, dont le comportement, la santé, l’alimentation, etc. Le logiciel FGP facilite la gestion de ces aspects en plus de l’ensemble des tâches administratives. Plusieurs établissements d’enseignement privés utilisent déjà FGP, un outil performant qui a fait ses preuves au fil du temps. Profitez de ces avantages :</p>
                </div>
                <div class="col col-12" *ngIf="currentLang ==='en'">
                    <h2 class="section-title">
                        <strong>Benefits and key features</strong>
                    </h2>
                    <p>Of course, school is a place for learning, but above all, it is a living environment for the students. Thus, the school interveners must ensure proper functioning of several aspects, among which behaviour, health, food, etc. The window on pedagogical management (FGP) (Fenêtre sur la Gestion Pédagogique) makes the whole administrative management much easier. A large number of private schools are already using the FGP, the performance of which has been validated over time. You can also benefit from these advantages: </p>
                </div>
            </div>

            <div class="row">
                <div class="col col-12 col-md-6">
                    <div class="row">
                        <div class="col-md-6">
                            <img src="assets/img/pages/characteristics_01.svg" />
                        </div>
                        <div class="col-md-6">
                            <div class="content">
                                <p *ngIf="currentLang ==='fr'">Numérisation complète des documents administratifs et élimination du papier.</p>
                                <p *ngIf="currentLang ==='en'">Complete digitalisation of administrative documents and elimination of paper consumption.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col col-12 col-md-6">
                    <div class="row">
                        <div class="col-md-6">
                            <img src="assets/img/pages/characteristics_02.svg" />
                        </div>
                        <div class="col-md-6">
                            <div class="content">
                                <p *ngIf="currentLang ==='fr'">Intégration des communications ministérielles de type Info-Sanction.</p>
                                <p *ngIf="currentLang ==='en'">Integration of departemental communications (Info-Sanction). .</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col col-12 col-md-6">
                    <div class="row">
                        <div class="col-md-6">
                            <img src="assets/img/pages/characteristics_03.svg" />
                        </div>
                        <div class="col-md-6">
                            <div class="content">
                                <p *ngIf="currentLang ==='fr'">Centralisation des données, ce qui évite la double entrée.</p>
                                <p *ngIf="currentLang ==='en'">Centralization of data, thus preventing double entry.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col col-12 col-md-6">
                    <div class="row">
                        <div class="col-md-6">
                            <img src="assets/img/pages/characteristics_04.svg" />
                        </div>
                        <div class="col-md-6">
                            <div class="content">
                                <p *ngIf="currentLang ==='fr'">Gestion des usagers pour permettre la saisie simultanée et rehausser le niveau de sécurité dans le système.</p>
                                <p *ngIf="currentLang ==='en'">Users management, allowing for simultaneous entry and increase of security levels.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>
<!-- end SECTION characteristics -->

<!-- SECTION - taquets -->
<app-taquets *ngIf="currentLang ==='fr'" [title]="taquets.title" [description]="taquets.description" [items]="[]">
    <div class="taquets-slides">
        <div class="taquets-slide active">

            <ul>
                <li>Convoquez les parents à des rencontres pour assurer la réussite des élèves.</li>
                <li>Accédez au dossier médical complet des élèves, notamment à leurs allergies et troubles ainsi qu’à leur plan d’intervention, s’il y a lieu.</li>
                <li>Transmettez des données ministérielles de façon simple et efficace.</li>
                <li>Gérez automatiquement les archives électroniques : saisie en ligne de l’information par les parents.</li>
                <li>Inscrivez des messages à plusieurs usagers en même temps (courriels en lot, etc.).</li>
                <li>Utilisez les choix de cours pour une gestion simple et rapide.</li>
                <li>Effectuez le suivi du comportement des élèves.</li>
                <li>Analysez les résultats scolaires, le taux d’échecs, etc. à l’aide de rapports performants.</li>
                <li>Enregistrez les données propres à votre école avec les variables locales.</li>
                <li>Recueillez les informations grâce aux formulaires web.</li>
                <li>Mettez à profit le menu Méritas pour les honneurs et mérites.</li>
                <li>Veillez aux absences des élèves, aux retards et aux sanctions.</li>
                <li>Profitez de notre assistant totalement personnalisable qui, intégré à certaines fonctions, vous accompagne lors d’étapes importantes.</li>
                <li>Gérez les horaires et le calendrier scolaire.</li>
                <li>Publiez rapidement des bulletins sans erreur grâce à l’analyseur de bulletin. </li>
                <li>Conservez les dossiers des anciens élèves de votre école.</li>
            </ul>

        </div>
        
    </div>
</app-taquets>
<app-taquets *ngIf="currentLang ==='en'" [title]="taquets.titleEN" [description]="taquets.descriptionEN" [items]="[]">
        <div class="taquets-slides">
            <div class="taquets-slide active">
    
                <ul>
                    <li>To convene the parents to various meetings to ensure the success for all children.</li>
                    <li>To have access to the students’ comprehensive medical records, specifically to their allergies, health issues and intervention plan if case arises.</li>
                    <li>To forward the corporate information in a simple and efficient way.</li>
                    <li>To automatically manage the electronic archives by online entry of information by the parents.</li>
                    <li>To use the Choice of courses menu for swift and simple management.</li>
                    <li>To ensure a follow-up of the children’s behaviour.</li>
                    <li>To analyse academic results and failure rates, with a high-performance report.</li>
                    <li>To enter your school’s data in the Local variables menu.</li>
                    <li>To gather information thanks to web forms.</li>
                    <li>To use the Merit menu for the honors and merits.</li>
                    <li>To manage the students’ attendance, late arrivals and sanctions.</li>
                    <li>To benefit from the advantages of our fully personalizable assistant which, when integrated to specific functions, will support you throughout specific crucial steps.</li>
                    <li>To manage the school schedules and calendar.</li>
                    <li>To swiftly issue error-free school reports, with the Report Analysis tool.</li>
                    <li>To keep your school former students’ records.</li>
                </ul>
    
            </div>
            
        </div>
    </app-taquets>
    <!-- end SECTION - taquets -->

<p>&nbsp;</p>
<p>&nbsp;</p>

<app-footer></app-footer>
